<template>
  <v-row class="px-1">
    <v-col v-for="(keyword, index) in keywords" :key="index" cols="3">
      <v-text-field
        :value="keyword"
        class="body-2"
        append-icon="mdi-close"
        :rules="[presenceValidation]"
        required
        dense
        @click:append="deleteKeyword(index)"
        @input="(val) => updateKeyword(val, index)"
      />
    </v-col>
    <v-col>
      <v-btn
        class="ma-1"
        small
        depressed
        outlined
        color="primary"
        @click="addKeyword"
      >
        <v-icon left small> mdi-plus </v-icon>
        追加
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  mixins: [formValidationUtils],
  props: {
    keywords: {
      type: Array,
      required: true
    }
  },
  methods: {
    updateKeyword (val, index) {
      let updatedKeywords = [...this.keywords]
      updatedKeywords[index] = val
      this.$emit('change-keywords', updatedKeywords)
    },
    deleteKeyword (index) {
      let updatedKeywords = [...this.keywords]
      updatedKeywords.splice(index, 1)
      this.$emit('change-keywords', updatedKeywords)
    },
    addKeyword () {
      let updatedKeywords = [...this.keywords]
      updatedKeywords.push('')
      this.$emit('change-keywords', updatedKeywords)
    }
  }
}
</script>
